import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useSocket } from '../../realtime/context/SocketContext';

export default function MyItems() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const socket = useSocket();

  const loadItems = () => {
    const params = filter !== 'all' ? { payment_status: filter } : {};
    return axios.get('/api/customer/items', { params })
      .then(r => setItems(r.data))
      .catch(() => {});
  };

  useEffect(() => {
    setLoading(true);
    loadItems().finally(() => setLoading(false));
  }, [filter]);

  useEffect(() => {
    if (!socket) return undefined;

    const handleStatusUpdated = () => {
      loadItems();
    };

    socket.on('status:updated', handleStatusUpdated);
    return () => socket.off('status:updated', handleStatusUpdated);
  }, [socket, filter]);

  return (
    <div>
      <div className="page-header">
        <Link to="/home" className="back-btn">←</Link>
        <h1>My Items 📦</h1>
      </div>

      <div style={{ display: 'flex', gap: 8, padding: '12px 16px', overflowX: 'auto' }}>
        {['all', 'unpaid', 'pending', 'paid'].map(f => (
          <button key={f} onClick={() => setFilter(f)} className="btn btn-sm"
            style={{ background: filter === f ? '#1A6B8A' : 'white', color: filter === f ? 'white' : '#6b7280', border: `1px solid ${filter === f ? '#1A6B8A' : '#e5e7eb'}`, whiteSpace: 'nowrap' }}>
            {f === 'all' ? 'All Items' : f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      <div className="page-content" style={{ paddingTop: 0 }}>
        {loading
          ? <div className="loading-center"><div className="spinner spinner-dark" /></div>
          : items.length === 0
            ? (
              <div className="empty-state">
                <div className="icon">📦</div>
                <p style={{ fontWeight: 600, fontSize: 16, marginBottom: 6 }}>No items yet</p>
                <p>Your shipments will appear here once your goods arrive at the warehouse.</p>
              </div>
            )
            : items.map(item => (
              <div className="card" key={item.id}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                  <p style={{ fontWeight: 700, fontSize: 14, flex: 1 }}>{item.goods_name || 'Goods'}</p>
                  <span className={`badge badge-${item.payment_status}`}>{item.payment_status}</span>
                </div>

                <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>
                  📦 {item.tracking_number || 'N/A'}
                </p>

                {/* Transport mode badge */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                  <span style={{
                    fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 20,
                    background: item.transport_mode === 'sea' ? '#e0f2fe' : '#f0fdf4',
                    color: item.transport_mode === 'sea' ? '#0369a1' : '#15803d'
                  }}>
                    {item.transport_mode === 'sea' ? '🚢 Sea' : '✈️ Air'}
                  </span>
                  <span style={{ fontSize: 12, color: '#6b7280' }}>
                    {item.transport_mode === 'sea'
                      ? `${item.volume_cbm} CBM`
                      : `${item.weight_kg} kg`}
                  </span>
                  <span className={`badge badge-${item.status}`} style={{ fontSize: 10, marginLeft: 'auto' }}>
                    {item.status?.replace(/_/g, ' ')}
                  </span>
                </div>

                {/* Price breakdown — transparent USD + GHS */}
                <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: 10, marginTop: 4 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                    <div>
                      <p style={{ fontSize: 11, color: '#9ca3af' }}>Shipping Fee</p>

                      {/* USD amount for transparency */}
                      {item.final_fee_usd && parseFloat(item.final_fee_usd) > 0 && (
                        <p style={{ fontSize: 12, color: '#6b7280' }}>
                          USD ${parseFloat(item.final_fee_usd).toFixed(2)}
                          {item.exchange_rate_used && (
                            <span style={{ fontSize: 10, color: '#9ca3af' }}> × {item.exchange_rate_used}</span>
                          )}
                        </p>
                      )}

                      {/* Strike through original if discount applied */}
                      {item.discount_applied > 0 && (
                        <p style={{ fontSize: 11, color: '#9ca3af', textDecoration: 'line-through' }}>
                          GHS {parseFloat(item.shipping_fee).toFixed(2)}
                        </p>
                      )}

                      <p style={{ fontSize: 18, fontWeight: 800, color: '#1A6B8A' }}>
                        GHS {parseFloat(item.final_fee).toFixed(2)}
                      </p>

                      {item.discount_applied > 0 && (
                        <p style={{ fontSize: 10, color: '#16a34a' }}>-{item.discount_applied}% discount applied</p>
                      )}
                    </div>

                    {item.payment_status === 'unpaid' && (
                      <Link to="/pay" state={{ itemId: item.id }} className="btn btn-primary btn-sm">Pay Now</Link>
                    )}
                  </div>
                </div>
              </div>
            ))
        }
      </div>
    </div>
  );
}
